import React from 'react'
import PropTypes from 'prop-types'
import { Dropdown } from 'shared/ui'
import { toDate } from 'util/date'
import { propFunc } from 'util/functions'
import { OPTIONS } from 'util/snooze'
import { omit } from 'util/objects'

const buildOptions = onClick => {
  return OPTIONS.map(opt => {
    const timestamp = opt.timestamp()
    return {
      ...omit(['indefinite'], opt),
      key: opt.value,
      format: undefined,
      timestamp: undefined,
      description: opt.format(timestamp),
      onClick: propFunc(
        onClick,
        opt.indefinite ? timestamp : toDate(timestamp)
      ),
    }
  })
}

const SnoozeDropdown = ({ onOptionClick, header, bindHotKey, ...rest }) => {
  return (
    <Dropdown
      {...rest}
      arrowColor="brightPink"
      selectedBgColor="lightPink"
      header={header}
      options={buildOptions(onOptionClick)}
    />
  )
}

SnoozeDropdown.propTypes = {
  /* Whether the dropdown menu is disabled */
  disabled: PropTypes.bool,

  header: PropTypes.string,

  // Standard SUI Callbacks
  onClose: PropTypes.func,
  onBlur: PropTypes.func,

  /* onClick handler for an option (should trigger the snooze) */
  onOptionClick: PropTypes.func.isRequired,
}

SnoozeDropdown.defaultProps = {
  disabled: false,
  header: 'Snooze',
  onBlur: undefined,
  onClose: undefined,
}

export default SnoozeDropdown
